import React from "react";
import { initials, colorFor } from "@/lib/format";
import { Users } from "lucide-react";

export default function Avatar({ name, online, isGroup, size = 44, showStatus = true }) {
  const style = { width: size, height: size, backgroundColor: isGroup ? "#334155" : colorFor(name) };
  return (
    <div className="relative flex-shrink-0">
      <div
        className="rounded-full flex items-center justify-center text-white font-semibold select-none"
        style={style}
      >
        {isGroup ? <Users className="h-1/2 w-1/2" /> : <span style={{ fontSize: size * 0.38 }}>{initials(name)}</span>}
      </div>
      {showStatus && !isGroup && (
        <span
          className={`absolute bottom-0 right-0 rounded-full border-2 border-card ${online ? "bg-green-500" : "bg-slate-400"}`}
          style={{ width: size * 0.28, height: size * 0.28 }}
          data-testid="avatar-status"
        />
      )}
    </div>
  );
}
